<template>
<div>
     <qb-panel title="Title" buttonTitle="Carregar mais">
        <qb-card get="products" :button="true" :modal="true"/>
     </qb-panel>
</div>
</template>

<script>
export default {
  data() {
      return {
        id: this.$route.params.id,
        urlProduto: "http://www.dreamfish.com.br/produtos/original/soft-marine-2l-8665.jpg"
      }
  }
}
</script>

<style>

</style>
